import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"download\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.2908 7.24917L9.91667 9.61417V0.75H8.08333V9.61417L5.70917 7.24917L4.41667 8.54167L9 13.125L13.5833 8.54167L12.2908 7.24917ZM15.4167 15.4167V9H17.25V15.4167C17.25 16.425 16.425 17.25 15.4167 17.25H2.58333C1.575 17.25 0.75 16.425 0.75 15.4167V9H2.58333V15.4167H15.4167Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol